import type { QuestionModule } from "../contracts";
import {
  rankSortCore,
  type RankSortDefinition,
  type RankSortDraft,
  type RankSortEvent,
  type RankSortRaw,
  type RankSortResponse,
} from "./core";
import { RankSortButtonsView, RankSortListView } from "./views";

export const rankSortModule: QuestionModule<
  RankSortRaw,
  RankSortDefinition,
  RankSortDraft,
  RankSortEvent,
  RankSortResponse
> = {
  type: "rank_sort",
  galleryFeatures: [
    "visual-groups",
    "baseline",
    "limits",
    "labels",
    "images",
    "option-images",
    "disabled",
    "restored",
    "dont-know",
  ],
  core: rankSortCore,
  prompt: (definition) => ({
    content: definition.prompt,
    image: definition.image,
    altText: definition.altText,
    error: definition.error,
  }),
  views: {
    buttons: {
      id: "buttons",
      label: "Buttons",
      component: RankSortButtonsView,
      space: "expanded",
      arrangements: ["compact", "wide"],
      requiredControls: ["primary-action"],
    },
    list: {
      id: "list",
      label: "List",
      component: RankSortListView,
      space: "expanded",
      arrangements: ["compact", "wide"],
      requiredControls: ["primary-action"],
    },
  },
  defaultDisplay: { view: "buttons" },
  resolveDisplay: (raw) => ({
    view: raw.style === "button" ? "buttons" : "list",
  }),
  controls: (_definition, _draft, _display, copy) => ({
    primaryAction: {
      purpose: "submit",
      label: copy.actions.send,
      action: { type: "submit" },
    },
  }),
};
